'use client'

import type { Data } from '@repo/strapi'
import { useMemo, useState } from 'react'
import { Container } from '@/components/elementary/Container'
import { BillingSwitch } from '@/components/page-builder/global/pricingV1/BillingSwitch'
import { FeatureComparison } from '@/components/page-builder/global/pricingV1/featureComparison'
import { FeaturedPlan } from '@/components/page-builder/global/pricingV1/featuredPlan'
import { PlanOverview } from '@/components/page-builder/global/pricingV1/overview'
import { MONTHLY_VISIBLE_PLANS } from '@/constants/pricing.constants'

export function PricingClient({
	data,
	stickyTopOffset,
	billingSwitchTagImage,
	billingSwitchArrowImage,
	featuredPlan,
	anchorId,
}: {
	readonly data?: Data.Component<'shared.pricing-plan-detail'>[] | null
	readonly stickyTopOffset?: number
	readonly billingSwitchTagImage?: Data.Component<'utilities.basic-image'>
	readonly billingSwitchArrowImage?: Data.Component<'utilities.basic-image'>
	readonly featuredPlan?: Data.Component<'shared.featured-plan-v1'> | null
	readonly anchorId?: string
	readonly className?: string | null
}) {
	const [yearly, setYearly] = useState(true)
	const [currentTab, setCurrentTab] = useState(data?.[0]?.title ?? '')

	const visibleData = useMemo(() => {
		if (!data) return data
		return yearly ? data : data.slice(0, MONTHLY_VISIBLE_PLANS)
	}, [data, yearly])

	return (
		<div id={anchorId}>
			{featuredPlan && <FeaturedPlan data={featuredPlan} />}

			<div className="pt-11.25 pb-22.5 bg-brand-black">
				<Container paddingX>
					<BillingSwitch
						data={data}
						yearly={yearly}
						setYearly={setYearly}
						currentTab={currentTab}
						setCurrentTab={setCurrentTab}
						tagImage={billingSwitchTagImage}
						arrowImage={billingSwitchArrowImage}
					/>
					<PlanOverview
						data={visibleData}
						yearly={yearly}
						currentTab={currentTab}
						setCurrentTab={setCurrentTab}
						stickyTopOffset={stickyTopOffset}
					/>
					<FeatureComparison
						data={visibleData}
						yearly={yearly}
						currentTab={currentTab}
						setCurrentTab={setCurrentTab}
					/>
				</Container>
			</div>
		</div>
	)
}
